import { render, staticRenderFns } from "./CommentsDialog.vue?vue&type=template&id=4fd61f06&scoped=true"
import script from "./CommentsDialog.vue?vue&type=script&lang=js"
export * from "./CommentsDialog.vue?vue&type=script&lang=js"
import style0 from "./CommentsDialog.vue?vue&type=style&index=0&id=4fd61f06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd61f06",
  null
  
)

export default component.exports